import { Button, Modal, ModalBody, ModalFooter } from '@eleveo/components-react';
import React from 'react';

export type ModalConfirmationNewStyleProps = {
  acceptCaption: string;
  cancelCaption: string;
  color?: 'error' | 'info' | 'success' | 'warning';
  isOpen: boolean;
  onAccept?: () => void;
  onCancel?: () => void;
  title: string;
} & React.PropsWithChildren;

export const ModalConfirmationNewStyle: React.FC<ModalConfirmationNewStyleProps> = ({
  acceptCaption,
  cancelCaption,
  children,
  color = 'error',
  isOpen,
  onAccept,
  onCancel,
  title,
}) => (
  <Modal onClose={onCancel} title={title} isOpen={isOpen}>
    <ModalBody>{children}</ModalBody>
    <ModalFooter>
      <Button onClick={onCancel} variant="outline" testId="modal:button-cancel">
        {cancelCaption}
      </Button>
      <Button color={color} onClick={onAccept} testId="modal:button-accept">
        {acceptCaption}
      </Button>
    </ModalFooter>
  </Modal>
);
